import { EGermanVatEntry, eGermanVatGet } from '../lib/mdl/e-german-vat';
import { UIButton } from '../lib/ui/component/button';
import { UITableDefinition, UITable } from '../lib/ui/component/table';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { $log } from '../lib/y/debug';
import { oauth, OAuth2Params } from '../lib/y/oauth';

export class AdminAccountingScreen extends UIScreen {
    constructor() {
        super();
    }

    protected override fillContent(content: UIViewSpec): void {
        content.ui_add(new UIButton({
            title: 'Connect to fortnox', on_click: () => {
                const params: OAuth2Params = {
                    response_type: 'code',
                    client_id: 'mhMEMUoMgc2r',
                    redirect_uri: 'https://admin.abundolive.se/oauth_callback.html',
                    scope: 'bookkeeping companyinformation',
                    // account_type: 'service',
                    access_type: 'offline'
                }

                oauth('https://apps.fortnox.se/oauth-v1/auth', params).then(response => {
                    $log('app', 'response', response);
                })

            }
        }));
    }
}

export class AdminGermanVATScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const def = new UITableDefinition<EGermanVatEntry>();
        def.addValue(u => u.month, { title: 'Month', width: 160 });
        def.addValue(u => u.cost_0, $fmt.CURRENCY, { title: 'Cost 0%', width: -160 });
        def.addValue(u => u.cost_7, $fmt.CURRENCY, { title: 'Cost 7%', width: -160 });
        def.addValue(u => u.cost_19, $fmt.CURRENCY, { title: 'Cost 19%', width: -160 });
        def.addValue(u => u.revenue, $fmt.CURRENCY, { title: 'Revenue', width: -160 });

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                new UITable(def, new YArrayDataSource(await eGermanVatGet())),
            ])),
        ]);
    }
}
